import type { InsertScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type InsertScimDomainInput = { domain: string };

const mapTrpcResponseToGraphQL = (trpcData: {
  domain: string;
  createdOn: string;
}): InsertScimDomainMutation => ({
  insert_scim_domain: {
    __typename: 'ScimDomainOutput',
    domain: trpcData.domain,
    createdOn: trpcData.createdOn,
  },
});

export const useInsertScimDomainTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.scim.addDomain.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.scim.getConfig.queryKey(),
        });
      },
    }),
  });

  return {
    insertScimDomain: async (
      variables: InsertScimDomainInput
    ): Promise<InsertScimDomainMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
